import {
  CommandBar,
  Panel,
  PanelType,
  ProgressIndicator,
} from "@fluentui/react";
import { Divider, InputNumber, notification } from "antd";
import Form from "antd/lib/form/Form";
import FormItem from "antd/lib/form/FormItem";
import TextArea from "antd/lib/input/TextArea";
import { Formik } from "formik";
import { toJS } from "mobx";
import { observer } from "mobx-react-lite";
import React, { createContext, useContext } from "react";
import { Target, X } from "react-feather";
import TargetStore from "../productiontarget/store/TargetStore";
import "../productiontarget/styles/monthtarget.css";
const targetstore = createContext(TargetStore);
export const MonthTargetForm = observer(() => {
  const targetStore = useContext(targetstore);
  return (
    <Panel
      headerText={`Set ${targetStore.mainStore.assetContextName} Poduction and Evacuation Targets for ${targetStore.selRow?.targetMonthModified} ${targetStore.targetYear}`}
      isOpen={targetStore.showTargetEditDialog}
      type={PanelType.medium}
      isFooterAtBottom={true}
      headerClassName="header"
      onDismiss={() => {
        targetStore.showTargetEditDialog = false;
      }}
      style={{ fontSize: "12px" }}
      isLightDismiss={true}
    >
      <CommandBar
        items={[
          {
            key: "clear",
            text: "Clear Entries",
            onRenderIcon: () => <X />,
            onClick: () => {
              targetStore.clearForm();
            },
          },
        ]}
        farItems={[
          {
            key: "save",
            text: "Lock Targets",
            buttonStyles: { root: { backgroundColor: "red", color: "white" } },

            onRenderIcon: () => (
              <Target className="qicon" style={{ color: "white" }} />
            ),
            onClick: async () => {
              try {
                const retVal = await targetStore.saveMonthTarget();
                if (retVal.success) {
                  targetStore.targets.set(
                    targetStore.selRow?.targetId,
                    targetStore.selRow
                  );
                  notification.success({
                    key: "error",
                    message: "SPARS Feedback",
                    description: `${targetStore.selRow.targetMonthModified} ${targetStore.selRow.targetYear} production and evacuation target set successfully`,
                  });
                  targetStore.showTargetEditDialog = false;
                }
              } catch (error) {
                notification.error({
                  key: "error",
                  message: "SPARS Feedback",
                  description: error.message,
                });
              } finally {
                targetStore.isSavingMonthlyTarget = false;
              }
              console.log(toJS(targetStore.selRow));
            },
          },
        ]}
      ></CommandBar>
      {targetStore.isSavingMonthlyTarget && (
        <ProgressIndicator
          description="locking target, please wait..."
          styles={{ root: { textAlign: "center" } }}
        ></ProgressIndicator>
      )}
      <Formik
        initialValues={toJS(targetStore.selRow)}
        enableReinitialize={true}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <Form
            layout="vertical"
            labelAlign="left"
            style={{ background: "#fff", padding: "10px" }}
          >
            <div className="ms-Grid" dir="ltr">
              <Divider style={{ color: "red" }}>Production Targets</Divider>
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm6">
                  <FormItem
                    label="Oil Produced Target(bopd)"
                    labelAlign="left"
                    className="add-border"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "80%" }}
                      name="oilProduced"
                      value={values?.oilProduced}
                      onChange={(value) => {
                        targetStore.selRow.oilProduced = value;
                      }}
                    />
                  </FormItem>
                </div>
                <div className="ms-Grid-col ms-sm6">
                  {" "}
                  <FormItem
                    label="Gas Produced Target(mmscf/d)"
                    labelAlign="left"
                    className="add-border"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "80%" }}
                      name="gasProduced"
                      value={values?.gasProduced}
                      onChange={(value) => {
                        targetStore.selRow.gasProduced = value;
                      }}
                    />
                  </FormItem>
                </div>
              </div>
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm6">
                  <FormItem
                    label="Condensate Target (bpd)"
                    labelAlign="left"
                    className="add-border"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "80%" }}
                      name="condensateTarget"
                      value={values?.condensateTarget}
                      onChange={(value) => {
                        targetStore.selRow.condensateTarget = value;
                      }}
                    />
                  </FormItem>
                </div>
                <div className="ms-Grid-col ms-sm6">
                  {" "}
                  <FormItem
                    label="NGL Target (bpd)"
                    labelAlign="left"
                    className="add-border"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "80%" }}
                      name="nglTarget"
                      value={values?.nglTarget}
                      onChange={(value) => {
                        targetStore.selRow.nglTarget = value;
                      }}
                    />
                  </FormItem>
                </div>
              </div>

              <Divider style={{ color: "green" }}>Evacuation Targets</Divider>
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm6">
                  <FormItem
                    label="OIL Received(Evacuation)Target(bopd)"
                    labelAlign="left"
                    className="add-border"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "80%" }}
                      name="oilEvacuated"
                      value={values?.oilEvacuated}
                      onChange={(value) => {
                        targetStore.selRow.oilEvacuated = value;
                      }}
                    />
                  </FormItem>
                </div>
                <div className="ms-Grid-col ms-sm6">
                  {" "}
                  <FormItem
                    label="GAS  Evacuation(Sales)[mmscf/d]"
                    labelAlign="left"
                    className="add-border"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "80%" }}
                      name="gasEvacuated"
                      value={values?.gasEvacuated}
                      onChange={(value) => {
                        targetStore.selRow.gasEvacuated = value;
                      }}
                    />
                  </FormItem>
                </div>
              </div>
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm6">
                  <FormItem
                    label="Condensate  Evacuation (bpd)"
                    labelAlign="left"
                    className="add-border"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "80%" }}
                      name="condensateEvacuated"
                      value={values?.condensateEvacuated}
                      onChange={(value) => {
                        targetStore.selRow.condensateEvacuated = value;
                      }}
                    />
                  </FormItem>
                </div>
                <div className="ms-Grid-col ms-sm6">
                  {" "}
                  <FormItem
                    label="NGL  Evacuation (bpd)"
                    labelAlign="left"
                    className="add-border"
                  >
                    <InputNumber
                      min={0}
                      style={{ minWidth: "80%" }}
                      name="nglEvacuated"
                      value={values?.nglEvacuated}
                      onChange={(value) => {
                        targetStore.selRow.nglEvacuated = value;
                      }}
                    />
                  </FormItem>
                </div>
              </div>

              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                  <FormItem
                    label="Comment/Remark"
                    labelAlign="left"
                    className="add-border"
                  >
                    <TextArea
                      min={0}
                      style={{ minWidth: "80%" }}
                      name="comments"
                      value={values?.comments}
                      onChange={({ target }) => {
                        targetStore.selRow.comments = target.value;
                      }}
                    />
                  </FormItem>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </Panel>
  );
});

